import { render, staticRenderFns } from "./ButtonActionsComponent.vue?vue&type=template&id=37ab4ff3"
import script from "./ButtonActionsComponent.vue?vue&type=script&lang=js"
export * from "./ButtonActionsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports